import { api } from "../services/axios"
import { useMutation, useQuery } from "react-query"

export const useSalvarRefreshToken = () => {
    return useMutation(
        async (ga) => {
            const { data } = await api.post("/googleapi/refresh-token", ga);
            return data;
        }
    );
};

export const useGetRefreshToken = (id) => {
    return useQuery(
        ["googleApi"],
        async () => {
            const { data } = await api.get(`/googleapi/${id}/refresh-token`);
            return data;
        },
        {
            enabled: id != 0 && id != undefined && id != null
        }
    );
};

export const useGetContas = (id) => {
    return useQuery(
        ["contas"],
        async () => {
            const { data } = await api.get(`/googleapi/sincronizar/contas/${id}`);
            return data;
        },
        {
            enabled: id != 0 && id != undefined && id != null
        }
    );
};

export const useGetPropriedades = () => {
    return useMutation(
        async (dados) => {
            const { data } = await api.post(`/googleapi/sincronizar/propriedades`, null, { params: dados });
            return data;
        }
    );
};

export const useGetUrl = () => {
    return useMutation(
        async (dados) => {
            const { data } = await api.post(`/googleapi/sincronizar/url`, null, { params: dados });
            return data;
        }
    );
};

export const useUpdateGoogleApi = () => {
    return useMutation(
        async (dados) => {
            const { data } = await api.put(`/googleapi`, dados);
            return data;
        }
    );
};

export const useDeleteObjetoGoogleApi = () => {
    return useMutation(
        async (id) => {
            const { data } = await api.delete(`/googleapi/${id}`);
            return data;
        }
    );
};

export const useGetTrafficBlogOpti = (idUsuarioWordpress, googleApi) => {
    return useQuery([idUsuarioWordpress, 'trafficBlog'],
        async () => {
            const { data, status } = await api.get(`/googleapi/trafego/${idUsuarioWordpress}`)
            return { data, status }
        },
        {
            enabled: idUsuarioWordpress !== 0 && googleApi != null && googleApi != undefined && googleApi != '' && googleApi?.idAnalytics != ""
        }
    )
};

export const useGetTrafficDiaAnterior = (idUsuarioWordpress, googleApi) => {
    return useQuery([idUsuarioWordpress, "trafego-dia-anterior"],
        async () => {
            const { data, status } = await api.get(`/googleapi/trafego-dia-anterior/${idUsuarioWordpress}`)
            return { data, status }
        },
        {
            enabled: idUsuarioWordpress !== 0 && googleApi != null && googleApi != undefined && googleApi != '' && googleApi?.idAnalytics != ""
        }
    )
};